import styled from "styled-components";

export const KeyList = styled.ul`
  color: ${({ theme }) => theme.colors.gray800};
  line-height: ${({ theme }) => theme.line.height.base};
  font-size: ${({ isMobile, theme }) =>
    isMobile ? theme.font.size.sm : theme.font.size.md};
  width: 13.75rem; // for Edge
  width: max-content;
`;
